import React from "react";
import ReactApexChart from "react-apexcharts";

const RadialChart = ({ sourceWise }) => {
  const labels = sourceWise?.labels || ["Facebook", "Google"];
  const counts = sourceWise?.series || [0, 0];
  const fbCount = Number(counts[0] || 0);
  const googleCount = Number(counts[1] || 0);
  const total = Number(sourceWise?.total) || (fbCount + googleCount);

  // Exact percentage shares
  const realFbPct = total > 0 ? (fbCount / total) * 100 : 0;
  const realGooglePct = total > 0 ? (googleCount / total) * 100 : 0;

  // Series values for ApexCharts visual arcs (minimum 1.5% visual arc for Google if count > 0)
  const series = [
    Number(realFbPct.toFixed(3)),
    googleCount > 0 ? Math.max(1.5, Number(realGooglePct.toFixed(3))) : 0,
  ];

  const options = {
    chart: {
      height: 350,
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 10,
          size: "45%",
        },
        track: {
          show: true,
          strokeWidth: "70%",
          margin: 12,
        },
        dataLabels: {
          name: {
            fontSize: "20px",
          },
          value: {
            fontSize: "16px",
            formatter: function (val, opts) {
              if (total <= 0) return "0.000%";

              const sIdx = opts?.seriesIndex;
              if (sIdx === 0) {
                return ((fbCount / total) * 100).toFixed(3) + "%";
              }
              if (sIdx === 1) {
                return ((googleCount / total) * 100).toFixed(3) + "%";
              }

              if (val > 50) {
                return ((fbCount / total) * 100).toFixed(3) + "%";
              }
              return ((googleCount / total) * 100).toFixed(3) + "%";
            },
          },
          total: {
            show: true,
            label: "Total",
            formatter: function () {
              return total.toLocaleString();
            },
          },
        },
      },
    },
    labels: labels,
    colors: ["#0ab39c", "#f46a6a"],
  };

  return (
    <React.Fragment>
      <ReactApexChart
        key={`radial-${fbCount}-${googleCount}-${total}`}
        options={options}
        series={series}
        type="radialBar"
        height="350"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export default RadialChart;
